var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';
var PageLayout = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledContainer, null,
        React.createElement(Grid, { container: true }, children)));
};
var StyledContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 24px;\n  padding-top: 0;\n"], ["\n  padding: 24px;\n  padding-top: 0;\n"])));
export default PageLayout;
var templateObject_1;
